import React, { useState } from 'react';
import '../../styles/components/ExploreEvents.css';
import { H2, Body1 } from '../../themes/typography';
import HappeningEvents from './HappeningEvents';
import TrendingVenues from './TrendingVenues';
import Cta from '../Buttons/Cta';

export default function ExploreEvents() {
    const [view, setView] = useState('happening-events');
    const [activeButton, setActiveButton] = useState('Happening Events');

    const handleButtonClick = (viewType, buttonName) => {
        setView(viewType);
        setActiveButton(buttonName);
    };

    return (
        <div className="events-banner-container">
            <div className="banner-container">
                <div className="banner-header-section">
                    <div className="banner-heading">
                        <H2 color="#F8A21E">Explore Surat</H2>
                    </div>
                    <div className="banner-description">
                        <Body1>
                            Discover the most exciting venues and the hottest events in town
                        </Body1>
                    </div>
                    <div className="banner-buttons">
                        <Cta
                            name="Happening Events"
                            onClick={() =>
                                handleButtonClick('happening-events', 'Happening Events')
                            }
                            transparent={activeButton !== 'Happening Events'}
                        />
                        {/* <Cta
                            name="Trending Venues"
                            onClick={() => handleButtonClick('trending-venues', 'Trending Venues')}
                            transparent={activeButton !== 'Trending Venues'}
                        /> */}
                    </div>
                </div>
                <div className="events-banner-section">
                    <div className="banners">
                        {view === 'happening-events' && <HappeningEvents />}
                        {view === 'trending-venues' && <TrendingVenues />}
                    </div>
                </div>
            </div>
        </div>
    );
}
